import {
	Card,
	CardContent,
	CardDescription,
	CardHeader,
	CardTitle,
} from '@/common/ui/card'

import { TagsManager } from '../../../components/TagManager'

export function TagsSettingsPage() {
	return (
		<Card>
			<CardHeader>
				<CardTitle>แท็กลูกค้า</CardTitle>
				<CardDescription>จัดการแท็กสำหรับจัดกลุ่มและค้นหาแชท</CardDescription>
			</CardHeader>
			<CardContent>
				<TagsManager />
			</CardContent>
		</Card>
	)
}
